/**
 * The `media` clause of `.mojoup/policy.json` (D193 phase 3, docs/plans/2026-10-diagrammer.md):
 * whether AI image models may be used here, which providers, how many images a day, and whether
 * each image waits for a person's yes.
 *
 *  - `imageGeneration`: `off`, `local-only` (only a model that runs on this computer), or
 *    `allowed`. Left out of a managed policy (an organisation's): off, until the organisation
 *    turns it on. Left out of a repository's own file, or with no file: allowed, with the
 *    person's own configured provider.
 *  - `providers`: the provider ids (model catalogue) that may make images. Left out: any the
 *    policy's `allowedProviders` lets through.
 *  - `maxImagesPerDay`: images made on this machine in one UTC day, at most.
 *  - `approval`: `ask` — every image an agent asks for waits for a person; `auto` (the default)
 *    — it is made once the other checks pass. An image a person asks for in the window is
 *    their own yes either way.
 *
 * AI image models never draw boxes, arrows or labels for the workbench: they make illustration
 * and styling, and every image they make says it is AI-generated. That is the product's rule,
 * not the clause's.
 *
 * Plain zod, no Node: the AIOE mirrors this byte for byte, and the webview imports the words.
 */
import { z } from "zod";
export const IMAGE_GENERATION_MODES = ["off", "local-only", "allowed"];
export const mediaPolicySchema = z.object({
    imageGeneration: z.enum(IMAGE_GENERATION_MODES).optional(),
    providers: z.array(z.string().min(1).max(100)).max(50).optional(),
    maxImagesPerDay: z.number().int().min(0).max(10_000).optional(),
    approval: z.enum(["auto", "ask"]).optional(),
});
//# sourceMappingURL=media.js.map